import { useEffect, useState } from 'react';
import '../../App.css'
import Avatar from './Avatar';
import Fade from 'react-reveal';
import Footer from '../Footer/Footer';
import Navbar from '../Header/Navbar';
import { PuffLoader } from 'react-spinners';
const loaderStyle = `
display : block;
margin: auto;
`;
const Projects = () => {
    const [loading, setloading] = useState(true);
    const [project, setProject] = useState([]);
    useEffect(() => {
        fetch('projects.json')
            .then(res => res.json())
            .then(data => {
                setProject(data)
                setloading(false);
            }
            )
    }, [project])
    return (
        <>
            {!loading && <>
                <Navbar></Navbar>

                <div id='abt' className='pt-5 pb-5'>

                    <div className="container text-white pt-5 pb-5">
                        <Fade bottom duration={2500} distance="40px">
                            <h1 className='title text-center fw-bold pb-2' ><span className='some'>Some of</span><span className='h'> My Projects</span></h1>

                        </Fade>
                        <div className="row row-cols-lg-3 row-cols-md-2 row-cols-sm-1 row-cols-1 pt-5 pb-4">
                            {
                                project.map(p => <Avatar key={p.id} p={p}></Avatar>)
                            }
                        </div>
                    </div>

                </div>
                <Footer></Footer></>}
                <PuffLoader loading={loading} css={loaderStyle} color={"#5ED9D7"} size={150}></PuffLoader>




        </>
    );
};

export default Projects;